var React = require('react');

function CheckedCalendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M5.75.75v1.5h4.5V.75h1.5v1.5h3a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75H1.25A.75.75 0 0 1 .5 15V3a.75.75 0 0 1 .75-.75h3V.75h1.5ZM14 6H2v8.25h12V6Zm-3.723 1.602 1.06 1.06-3.712 3.713-2.652-2.652 1.062-1.06 1.59 1.591 2.653-2.652h-.001Z"}));
}

CheckedCalendar.defaultProps = {"fill":"none","viewBox":"0 0 16 16"};

module.exports = CheckedCalendar;

CheckedCalendar.default = CheckedCalendar;
